import React from 'react';
import { X, Calendar, FileText, Edit, Trash2 } from 'lucide-react';
import { onlyDate } from './OtherCompanyCRMModal';

export default function NoteDetailsModalExternal({ open, onClose, note, onEdit, onDelete }) {
  if (!open || !note) return null;

  return (
    <div className="fixed inset-0 z-[90]">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4 overflow-auto">
        <div className="w-full max-w-3xl my-4 rounded-2xl bg-white border shadow-2xl overflow-hidden flex flex-col max-h-[calc(100vh-2rem)]">
          {/* Header */}
          <div className="px-6 py-4 bg-gradient-to-r from-[#0c3b66] to-[#0488AF] text-white flex items-center justify-between flex-none">
            <div className="flex items-center gap-3 min-w-0">
              <div className="p-2 rounded-lg bg-white/10 border border-white/20">
                <FileText className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <div className="text-lg font-semibold">{note.title || 'Sin título'}</div>
                {note.date && (
                  <div className="text-sm text-white/80 mt-1 flex items-center gap-1">
                    <Calendar className="w-3.5 h-3.5" />
                    {onlyDate(note.date)}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              {onEdit && (
                <button 
                  onClick={() => {
                    onClose();
                    onEdit();
                  }}
                  className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors flex-shrink-0" 
                  title="Editar"
                >
                  <Edit className="w-4 h-4 text-white" />
                </button>
              )}
              {onDelete && (
                <button 
                  onClick={() => {
                    onClose();
                    onDelete();
                  }}
                  className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors flex-shrink-0" 
                  title="Eliminar"
                >
                  <Trash2 className="w-4 h-4 text-white" />
                </button>
              )}
              <button onClick={onClose} className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors flex-shrink-0" title="Cerrar">
                <X className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>

          {/* Body */}
          <div className="p-6 overflow-y-auto flex-1">
            <div className="space-y-4">
              {note.date && (
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Calendar className="w-4 h-4" />
                  <span>Fecha: {onlyDate(note.date)}</span>
                </div>
              )}
              
              {note.title && (
                <div>
                  <h3 className="text-sm font-medium text-gray-700 mb-2">Título</h3>
                  <div className="p-3 rounded-xl border border-gray-200 bg-gray-50">
                    <p className="text-base font-semibold text-gray-800">{note.title}</p>
                  </div>
                </div>
              )}

              {note.body && (
                <div>
                  <h3 className="text-sm font-medium text-gray-700 mb-2">Contenido</h3>
                  <div className="p-4 rounded-xl border border-gray-200 bg-gray-50">
                    <p className="text-base text-gray-800 whitespace-pre-wrap break-words">{note.body}</p>
                  </div>
                </div>
              )}

              {!note.title && !note.body && (
                <div className="text-center py-8 text-gray-500">
                  Esta nota no tiene contenido.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

